import { TopDialogUtils } from './utils';
import { TopDialogWorker } from './worker';
import { isVisible, querySelectorAllArray, querySelectorVisible } from '@/core/utils/dom';
import { historySetState } from '@/core/utils/route';
import type { ElTopDialog, ElTopDialogWrapper } from '@/components/dialog/lib/types';

let inited = false;

/**
 * Инициализация глобальных событий для диалоговых окон
 *
 * Производится один раз при подключении диалогового окна
 *
 * События не размонтируются
 */
export const initDialogGlobalEvents = () => {
	if (inited) return;
	inited = true;

	/**
	 * Закрытие диалога по Esc
	 */
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		if (!e.target || !(e.target instanceof HTMLElement)) return;

		const el = e.target;

		// событие произошло вне диалогового окна
		if (!el.closest('.ui-dialog')) return;

		if (el.contentEditable === 'true' || el.contentEditable === 'plaintext-only') return;

		// не закрывать окно при открытом TopPopup
		if (querySelectorVisible(document.documentElement, '.top-popup-wrapper')) return;

		// не закрывать окно при работе с jquery autocomplete
		if (el.classList.contains('autocomplete')) return;

		// не закрывать окно при открытом fancybox
		if (querySelectorVisible(document.documentElement, '.fancybox-container')) return;

		const elDialogs = querySelectorAllArray<ElTopDialog>(document, '.ui-dialog-content').filter((elDialog) => {
			return isVisible(elDialog);
		});

		$(elDialogs[elDialogs.length - 1]).dialog('close');
	});

	/**
	 * Закрытие диалога по кнопке закрыть
	 */
	document.addEventListener('click', (e) => {
		// // навигация без истории
		// var $dialog = $(this).closest('.ui-dialog-content');
		// var viewName = $dialog.attr('id');
		// var pageName = getHash('view-' + viewName);
		// if (!pageName) {
		// 	toPrevPage($dialog);
		//
		// 	return;
		// }
		//
		// // навигация по истории
		// if (Core.state.isMobile && history.length > 1 && $(this).closest('.modal-layer').length) {
		// 	var href = location.href;
		//
		// 	history.go(-1);
		//
		// 	setTimeout(() => {
		// 		// это первая страница в истории вкладки браузера
		// 		if (href === location.href) $(e.target).closest('.ui-dialog-content').dialog('close');
		// 	});
		// } else {
		// 	$(this).closest('.ui-dialog-content').dialog('close');
		// }

		if (!(e.target instanceof HTMLElement)) return;

		const el = e.target.closest('[data-action="top-dialog-close"]') as HTMLElement | null;
		if (!el) return;

		e.preventDefault();

		const elDialog = el.closest<ElTopDialog>('.ui-dialog-content');
		if (!elDialog) return;

		// если к кнопке привязана ссылка, диалоговое окно не нужно закрывать
		const toView = el.dataset.toView;

		if (toView == 'toPrevPage()') {
			TopDialogUtils.toPrevPage(elDialog);

			return;
		}

		if (toView) {
			const viewNameAndPageLink = toView.split('-');
			const viewName = viewNameAndPageLink.shift();
			const pageLink = viewNameAndPageLink.join('-');

			if (!viewName) return;

			const elDialog = TopDialogUtils.getElDialogById(viewName);
			if (!elDialog) return;

			const elToPages = querySelectorAllArray(elDialog, `[data-view-page="${pageLink}"]`);
			if (!elToPages) return;

			if (!isVisible(elToPages[0])) {
				const hash = TopDialogWorker.genViewPageHash(toView, 'prev');

				// // не убирает кнопку "Вперед" в браузере
				// history.replaceState(null, '', hash);
				// toViewDirty(toView, 'prev');

				// // добавляет текущую страницу в историю браузера
				historySetState(false, hash);

				return;
			}
		}

		const $dialog = $(elDialog);

		$dialog.dialog('close');
	});

	/**
	 * Все submit должны обрабатываться через js
	 */
	document.addEventListener('submit', (e) => {
		const elForm = e.target as HTMLElement;

		if (elForm.matches('.modal-body > form') || elForm.matches('.modal-layer-body > form')) {
			e.preventDefault();
		}
	});

	/**
	 * Выполнение действия по нажатию Enter
	 *
	 * @todo Убрать `.searcher`
	 */
	document.addEventListener('keypress', (e) => {
		if (!(e.target instanceof HTMLElement)) return;

		const eventTarget = e.target;

		const elModalBody = eventTarget.closest('.ui-dialog .modal-body');
		if (!elModalBody) return;

		const isInput =
			eventTarget.matches('input:not(.searcher), textarea:not(.searcher), select:not(.searcher), button:not(.searcher)')
			|| eventTarget.hasAttribute('contenteditable');
		if (!isInput) return;

		// if (e.keyCode !== 10 && e.key !== 'ENTER') return;
		if (e.key !== 'Enter') return;

		// не выполнять submit действий при работе с jquery autocomplete
		if (eventTarget.classList.contains('autocomplete')) {
			e.preventDefault();

			return;
		}

		if (eventTarget.tagName === 'TEXTAREA') {
			if (!e.ctrlKey && !e.metaKey) return;

			const elForm = eventTarget.closest('form');

			if (elForm) {
				// Find visible submit buttons
				const elSubmitButton = querySelectorAllArray(elForm, 'button[type="submit"]')
					.concat(querySelectorAllArray(elForm, 'input[type="submit"]'))
					.find((elSubmitButton) => {
						return isVisible(elSubmitButton);
					});

				elSubmitButton?.click();
			}
		}
	});

	/**
	 * Закрытие диалога по клику вне окна
	 */
	document.addEventListener('click', function (event) {
		if (!(event.target instanceof HTMLElement)) return;

		const eventTarget = event.target;

		if (!eventTarget.classList.contains('ui-widget-overlay')) return;

		let elDialogWrapperWithTopZIndex: ElTopDialogWrapper | undefined;
		let topZIndex = 0;

		const elDialogWrapperVisibles = querySelectorAllArray<ElTopDialogWrapper>(document, '.ui-dialog').filter((elDialogWrapper) => {
			return isVisible(elDialogWrapper);
		});

		elDialogWrapperVisibles.forEach((elDialogWrapper) => {
			const zIndex = Number(window.getComputedStyle(elDialogWrapper).zIndex);
			if (zIndex < topZIndex) return;

			elDialogWrapperWithTopZIndex = elDialogWrapper;
			topZIndex = zIndex;
		});

		if (elDialogWrapperWithTopZIndex) {
			const elDialog = elDialogWrapperWithTopZIndex.querySelector('.ui-dialog-content');

			$(elDialog).dialog('close');
		}
	});

	window.addEventListener('resize', TopDialogUtils.recalcPositions);
	TopDialogUtils.recalcPositions();
};
